import { h, hydrate } from 'preact'
import { Provider as CustomProvider } from './lib/context'
import { Banner } from './components/Banner/Banner'
import coreScroll from '@nrk/core-scroll'

import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

import { BaseElement, PartialCoreAnalyticsGAData } from '@nrk/dh-server-libs/base-element'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends BaseElement {
  name = tag

  render() {
    const sendGaEvent = (event: PartialCoreAnalyticsGAData) => {
      this.sendGaEvent(event)
    }

    hydrate(
      <CustomProvider value={{ sendGaEvent }}>
        <Banner {...(this.preloadedState as any)} />
      </CustomProvider>,
      this
    )
    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })
    this.initCoreScrollScroll()
  }

  initCoreScrollScroll() {
    coreScroll('#scroll')
  }
}

safeDefine(tag, AppElement)
